<template>
  <div class="glapp" ref="root">
    <canvas class="webgl" id="canvas" ref="canvas" />
    <video id="video" autoplay playsinline ref="video" />
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, onUnmounted, ref } from 'vue';
import App from './App.js';

const root = ref(null);
const GLApp = ref(null);
const canvas = ref(null);
const video = ref(null);

onMounted(async() => {
  GLApp.value = new App({ 
    canvas: canvas.value, 
    video: video.value
  });

  await nextTick();
  canvas.value.removeAttribute('style');
});

onBeforeUnmount(() => {
  GLApp.value.destroy();
});

const takePicture = () => {
  GLApp.value.experience.takePhotoFunction();
}

const retakePicture = () => {
  GLApp.value.experience.retakePhotoFunction();
}

const generatePoster = (posterName) => {
  GLApp.value.experience.generatePosterFunction(posterName);
}

const URLPoster = computed(() => GLApp.value.experience.URLPoster);

const namePoster = computed(() => GLApp.value.experience.namePoster);

defineExpose({ takePicture, retakePicture, generatePoster, URLPoster, namePoster });
</script>

<style lang="stylus" scoped>
.glapp
  position relative
  inset 0
  width 69vh
  z-index 2
  +mobile()
    width 32.5vh

canvas
  position relative
  inset 0
  full()

video
  display none
</style>